import React from "react"
import styled from "styled-components"
import { Flex } from "rebass"

const Video = styled.video`
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  -ms-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  background: url(polina.jpg) no-repeat;
  background-size: cover;
`

const FullPageVideo = ({ children, video }) => (
  <Flex
    style={{
      minHeight: "100vh",
      maxWidth: "100vw",
      overflowX: "hidden",
    }}
  >
    <Video playsinline autoPlay muted="muted" loop id="bgvid">
      <source src={video} type="video/mp4" />
    </Video>
    {children}
  </Flex>
)

export default FullPageVideo



// WEBPACK FOOTER //
// ./src/components/FullPageVideo/index.js